import { GpsType } from '../../../../../../../global/components/layout/layout-models';
import { RsvpPlanAdoptionContentModel } from '../../models/plan-adoption-form-models';
import { LayDcPlanAdoptionWizard } from '../lay-dc/lay-dc-plan-adoption-wizard';

export class RsvpPlanAdoptionWizard extends LayDcPlanAdoptionWizard {
    
    getFormContentModel(): RsvpPlanAdoptionContentModel {

        const institutionSettings = this.epiContent?.institutionSettingsState?.epiContent;
        const content = super.getFormContentModel();

        return {
            ...content,
            pageTitle: institutionSettings?.adoptLayRSVPDetailsTitle,
            PageDescription: institutionSettings?.adoptRSVPDetailsDescription,
            adoptMinScheduleHoursHelperText: institutionSettings?.adoptRSVPMinScheduleHoursHelperText,
            adoptMultipleContributionDescription: institutionSettings?.adoptRSVPMultipleContributionDescription,
            gpsType: GpsType.RsvpAdoptionDetail,            
        };
    }
}